const res = {
//   pdfUrl: "/sample.pdf"  // No need for full path, just root-relative
     pdfUrl: "https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf"
};

export default res; 
